import { render } from "./MiniLessonPlayer.vue?vue&type=template&id=2cb36924"
import script from "./MiniLessonPlayer.vue?vue&type=script&lang=ts"
export * from "./MiniLessonPlayer.vue?vue&type=script&lang=ts"

import "./MiniLessonPlayer.vue?vue&type=style&index=0&id=2cb36924&lang=scss"
script.render = render

export default script